import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 ps-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer w-full",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_account_profile_details",
    "aria-expanded": "true",
    "aria-controls": "kt_account_profile_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Research Study Details")
    ])
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " This research study proposal is", -1)
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_9 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " If the proposal is a grant application, indicate the funding agency ", -1)
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = { class: "fw-bold fs-6" }
const _hoisted_13 = { class: "row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " How many months do you anticipate this research will last from the time final approval is granted? ", -1)
const _hoisted_15 = { class: "col-lg-6 fv-row" }
const _hoisted_16 = { class: "fw-bold fs-6" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Data gathering start date ", -1)
const _hoisted_19 = { class: "col-lg-6 fv-row" }
const _hoisted_20 = { class: "fw-bold fs-6" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Data gathering end date ", -1)
const _hoisted_23 = { class: "col-lg-6 fv-row" }
const _hoisted_24 = { class: "fw-bold fs-6" }
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is this research funded by an internal or external agency? ", -1)
const _hoisted_27 = { class: "col-lg-6 fv-row" }
const _hoisted_28 = { class: "fw-bold fs-6" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, "Selected Agency", -1)
const _hoisted_32 = { class: "col-lg-6 fv-row" }
const _hoisted_33 = { class: "fw-bold fs-6" }
const _hoisted_34 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Agency Name ", -1)
const _hoisted_36 = { class: "col-lg-6 fv-row" }
const _hoisted_37 = { class: "fw-bold fs-6" }
const _hoisted_38 = { class: "row mb-7" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is notification of IRB approval required by the granting agency? ", -1)
const _hoisted_40 = { class: "col-lg-6 fv-row" }
const _hoisted_41 = { class: "fw-bold fs-6" }
const _hoisted_42 = { class: "row mb-7" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will this research be utilizing Gannon University student academic records? (E.g., grades, test scores, reflection assignments, etc.). ", -1)
const _hoisted_44 = { class: "col-lg-6 fv-row" }
const _hoisted_45 = { class: "fw-bold fs-6" }
const _hoisted_46 = {
  key: 2,
  class: "row mb-7"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please list all academic records to be used by this research. ", -1)
const _hoisted_48 = { class: "col-lg-6 fv-row" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "row mb-7" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is this research being reviewed by any other institutional review board? ", -1)
const _hoisted_52 = { class: "col-lg-6 fv-row" }
const _hoisted_53 = { class: "fw-bold fs-6" }
const _hoisted_54 = {
  key: 3,
  class: "row mb-7"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please enter the name of the institution ", -1)
const _hoisted_56 = { class: "col-lg-6 fv-row" }
const _hoisted_57 = { class: "fw-bold fs-6" }
const _hoisted_58 = { class: "row mb-7" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Do any of the Investigators or personnel listed on this research have a potential conflict of interest associated with this study? ", -1)
const _hoisted_60 = { class: "col-lg-6 fv-row" }
const _hoisted_61 = { class: "fw-bold fs-6" }
const _hoisted_62 = { key: 4 }
const _hoisted_63 = { class: "row mb-7" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please select the investigator ", -1)
const _hoisted_65 = { class: "col-lg-6 fv-row" }
const _hoisted_66 = { class: "fw-bold fs-6" }
const _hoisted_67 = { class: "row mb-7" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please select the category of conflict of interest ", -1)
const _hoisted_69 = { class: "col-lg-6 fv-row" }
const _hoisted_70 = { class: "fw-bold fs-6" }
const _hoisted_71 = { class: "row mb-7" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please describe the conflict of interest ", -1)
const _hoisted_73 = { class: "col-lg-6 fv-row" }
const _hoisted_74 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteSection = _resolveComponent("NoteSection")!
  const _component_ViewActions = _resolveComponent("ViewActions")!
  const _component_Documents = _resolveComponent("Documents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NoteSection, { type: _ctx.modalNoteType }, null, 8, ["type"]),
    _createVNode(_component_ViewActions, {
      "route-name": "view-research-activities",
      "route-name-edit": "edit-research-study"
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentResearch.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentResearch.data.researchProposals, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      (item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.text), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              (!!_ctx.currentResearch.data.fundingAgency)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentResearch.data.fundingAgency), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentResearch.data.duration), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.moment(_ctx.currentResearch.data.startDate)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.moment(_ctx.currentResearch.data.endDate)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currentResearch.data.agencyType), 1)
                ])
              ]),
              (_ctx.currentResearch.data?.agencyType !== 'Not Funded Research')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.currentResearch.data?.agency), 1)
                      ])
                    ]),
                    (
              _ctx.currentResearch.data?.agency === 'State Agency' ||
              _ctx.currentResearch.data?.agency === 'Company' ||
              _ctx.currentResearch.data?.agency === 'Organization' ||
              _ctx.currentResearch.data?.agency === 'Others'
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.currentResearch.data?.agencyOther), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.currentResearch.data.isRequiredGrant ? "Yes" : "No"), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.currentResearch.data.isUtilizeAcademicRecord ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentResearch.data.isUtilizeAcademicRecord)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", {
                        class: "fw-bold fs-6",
                        innerHTML: _ctx.currentResearch.data.allAcademicRecords
                      }, null, 8, _hoisted_49)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.currentResearch.data.isReviewed ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentResearch.data.isReviewed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.currentResearch.data.reviewerName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.currentResearch.data.hasConflict ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentResearch.data.hasConflict)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.currentResearch.data.investigatorId), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.currentResearch.data.description), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("span", {
                          class: "fw-bold fs-6",
                          innerHTML: _ctx.currentResearch.data.coiDescription
                        }, null, 8, _hoisted_74)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Documents, {
      classification: "Research-Study",
      hiddeDelete: "true"
    })
  ], 64))
}